import { RootState } from 'handlers';

export const getAmountPerPaycheck = (state: RootState) => ({
  amountPerPaycheck: state.reports.amountPerPaycheck,
  isLoading: state.reports.isAmountPerPaycheckLoading,
  isError: state.reports.isAmountPerPaycheckError,
});
